import React from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import MultipleFileUploadForFiles from "./MultipleFileUploadForFiles";

export default function UploadChatFiles({
  setfileModel,
  selectUser,
  id1,
  id2,
  posts,
  type,
}) {
  return (
    <div className="rent-product">
      <div className="modal-head">
        <h6>Upload Files with Chat</h6>
        <button onClick={() => setfileModel((state) => !state)} className="btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
            alt=""
          />
        </button>
      </div>
      <MultipleFileUploadForFiles
        setfileModel={setfileModel}
        selectUser={selectUser}
        id1={id1}
        id2={id2}
        posts={posts}
        type={type}
      />
    </div>
  );
}
